module.exports = __webpack_public_path__ + "static/media/energy-square.4abb3c2e.jpg";